import { FileText } from "lucide-react";
import { API } from "@/lib/api";

/** Sources IA : extraits de notices constructeurs cités par l'assistant, ouvrables à la bonne page. */
export const SourcesNotices = ({ sources, sombre = false }) => {
  if (!sources?.length) return null;
  return (
    <div className="space-y-1.5" data-testid="ia-sources">
      <div className={`text-[11px] uppercase tracking-[0.2em] ${sombre ? "text-white/40" : "text-slate-400"}`}>
        Notices constructeurs citées
      </div>
      {sources.map((s) => (
        <a
          key={`${s.notice_id}-${s.page}`}
          href={`${API}/notices/${s.notice_id}/fichier?page=${s.page}#page=${s.page}`}
          target="_blank"
          rel="noreferrer"
          data-testid={`ia-source-${s.notice_id}-${s.page}`}
          className={`flex items-start gap-2 text-sm transition-colors ${sombre ? "text-white/75 hover:text-white" : "text-slate-600 hover:text-[#005CFF]"}`}
        >
          <FileText size={14} className="mt-0.5 shrink-0 text-[#4D93FF]" />
          <span>
            {s.titre} — page {s.page}
          </span>
        </a>
      ))}
    </div>
  );
};

export default SourcesNotices;
